import React, { useState } from 'react';
interface ThemeContextProps {
  isDarkMode: boolean;
  setTheme: (theme: 'dark' | 'light') => void;
  theme: string;
}
export const getInitialTheme = () => {
  if (
    window.matchMedia('(prefers-color-scheme: dark)').matches &&
    process.env.REACT_APP_DARK_MODE_ENABLED === 'true'
  ) {
    return 'dark';
  }
  return 'light';
};

export const ThemeContext = React.createContext<ThemeContextProps>({
  isDarkMode: false,
  setTheme: () => null,
  theme: '',
});
interface ThemeProviderProps {
  initialTheme?: string;
  children?: React.ReactNode;
}
export const ThemeProvider = ({
  initialTheme,
  children,
}: ThemeProviderProps) => {
  const [theme, setTheme] = useState<string>(getInitialTheme);
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);

  const checkTheme = existing => {
    const root = window.document.documentElement;
    const isDark =
      existing === 'dark' && process.env.REACT_APP_DARK_MODE_ENABLED === 'true';
    setIsDarkMode(isDark);
    root.classList.remove(isDark ? 'light' : 'dark');
    root.classList.add(existing);
    window.document.documentElement.style.colorScheme = theme;
  };

  if (initialTheme) {
    checkTheme(initialTheme);
  }

  React.useEffect(() => {
    checkTheme(theme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
